module.exports = __webpack_public_path__ + "img/kh8.d6550fa2.png";